import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { BookitoBookingFormValues } from '../shared/types';
import { useScreenKeyboard } from '../../KeyBoard/useScreenKeyboard';
import { KeyBoard } from '../../KeyBoard/KeyBoard';

type Props = {
  enabledKeyboard?: boolean;
};

function ExtraWishesInput({ enabledKeyboard, ...rest }: Props) {
  const { values, setValues } = useFormikContext<BookitoBookingFormValues>();

  const onUpdateFormValues = (updatedValues: Partial<BookitoBookingFormValues>) => {
    setValues({
      ...values,
      ...updatedValues,
    });
  };

  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState(false);

  const { keyboardType, handleKeyPress, handleSetFocus } = useScreenKeyboard({
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      onUpdateFormValues({ comment: e.target.value });
    },
  });

  return (
    <div className="mt-6">
      <p className="mb-2">
        <Trans>extra-wishes</Trans>
      </p>
      <textarea
        readOnly={enabledKeyboard} // prevent mobile keyboard from opening
        onChange={(e) => onUpdateFormValues({ comment: e.target.value })}
        value={values.comment}
        className="rounded-md text-black bg-white focus:outline-none border-gray-400 min-h-[60px] w-full"
        placeholder={t('add-a-comment-to-your-booking-request')}
        onFocus={(e: any) => {
          if (!enabledKeyboard) return;
          setIsFocused(true);
          handleSetFocus(e.target);
        }}
        onBlur={(e: any) => {
          setIsFocused(false);
        }}
      />
      {isFocused && <KeyBoard handleKeyPress={handleKeyPress} keyboardType={keyboardType} />}
    </div>
  );
}

export default ExtraWishesInput;
